<template>
  <vue-final-modal
    :value="visible"
    name="private-relay-warning-dialog"
    :classes="['private-relay-warning-dialog__container']"
    :content-class="[
      'private-relay-warning-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="false"
    :esc-to-close="false"
    :lock-scroll="true"
    attach="body"
    :z-index-base="10000"
    @input="onVisibleInput"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="close"
        icon="el-icon-circle-close"
        type="text"
      ></el-button>
    </div>
    <div class="private-relay-warning">
      <p class="private-relay-warning__icon">⚠️</p>
      <h3 class="private-relay-warning__title">メールアドレスのご確認</h3>
      <p class="private-relay-warning__txt">
        現在、Appleの「メールを非公開」機能をご利用中のため、各種お知らせメールが届かない場合があります。
      </p>
      <ul class="private-relay-warning__list">
        <li>お支払いの確認・更新のお知らせ</li>
        <li>メール便の送信通知・企業からの返信</li>
      </ul>
      <p class="private-relay-warning__txt">
        正常にサービスをご利用いただくために、受信可能なメールアドレスへの変更をおすすめします。
      </p>
      <div class="private-relay-warning__actions">
        <a href="/mypage/basicinfo" class="private-relay-warning__btn-primary"
          >メールアドレスを変更する</a
        >
        <button @click="proceed" class="private-relay-warning__btn-secondary">
          このまま購入する
        </button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * Apple Private Relay 警告（vue-final-modal）。
 * open は mitt（show-private-relay-warning）。未移行 hub 発火は emitter forward。
 */
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'

const SHOW_PRIVATE_RELAY_WARNING = 'show-private-relay-warning'

const visible = ref(false)
const onProceed = ref<(() => void) | null>(null)

function show(callback?: (() => void) | null) {
  onProceed.value = callback || null
  visible.value = true
}

function close() {
  onProceed.value = null
  visible.value = false
  emitter.emit('loading_off')
}

function onVisibleInput(value: boolean) {
  if (value) {
    visible.value = true
    return
  }
  if (!visible.value) return
  onProceed.value = null
  visible.value = false
  emitter.emit('loading_off')
}

function proceed() {
  const callback = onProceed.value
  onProceed.value = null
  visible.value = false
  if (callback) {
    callback()
  }
}

onBeforeMount(() => {
  emitter.on(SHOW_PRIVATE_RELAY_WARNING, show)
})

onBeforeUnmount(() => {
  emitter.off(SHOW_PRIVATE_RELAY_WARNING, show)
})
</script>

<style scoped>
.private-relay-warning {
  padding: 30px 20px;
  text-align: center;
}

.private-relay-warning__icon {
  font-size: 40px;
  margin-bottom: 10px;
}

.private-relay-warning__title {
  font-size: 18px;
  font-weight: bold;
  color: #e3165c;
  margin-bottom: 15px;
}

.private-relay-warning__txt {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.6;
}

.private-relay-warning__list {
  text-align: left;
  display: inline-block;
  margin: 10px 0 15px;
  padding-left: 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}

.private-relay-warning__actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.private-relay-warning__btn-primary {
  display: inline-block;
  background: #e3165c;
  color: #fff;
  padding: 10px 30px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  border: none;
  cursor: pointer;
}

.private-relay-warning__btn-primary:hover {
  opacity: 0.85;
  text-decoration: none;
  color: #fff;
}

.private-relay-warning__btn-secondary {
  background: none;
  border: none;
  color: #999;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 15px;
}

.private-relay-warning__btn-secondary:hover {
  color: #666;
}
</style>

<style lang="scss">
.private-relay-warning-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 10000;
}

.private-relay-warning-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  height: auto;
  margin-block: auto;
  border-radius: 8px;
  padding: 20px;
}
</style>
